// https://developers.facebook.com/docs/sharing/webmasters

import React, { useCallback, useEffect, useState } from 'react';
import window from 'window-or-global';

import { Facebook as IconFacebook } from 'react-feather';

interface Props {
  url?: string; // by default - window.location.href
  domain?: string;
  // children?: JSX.Element | string;
  shouldOpenWindow?: boolean;
  size?: number;
  className?: string;
}

const openWindowProps =
  'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600';

export const FacebookShareButton = ({
  // children,
  shouldOpenWindow = true,
  size = 16,
  className,
  url: propsUrl,
  ...props
}: Props) => {
  const [url, setUrl] = useState(propsUrl ? encodeURIComponent(propsUrl) : '');

  const link = `https://www.facebook.com/sharer/sharer.php?u=${url}`;

  const openWindow = useCallback(
    (event) => {
      event.preventDefault();
      window.open(link, '', openWindowProps);
    },
    [link]
  );

  useEffect(() => {
    if (!propsUrl) {
      setUrl(window.location.href);
    }
  }, [propsUrl]);

  return (
    <a
      {...props}
      href={link}
      className={className}
      target="_blank"
      rel="nofollow noreferrer"
      onClick={shouldOpenWindow ? openWindow : undefined}
    >
      <IconFacebook width={size} height={size} />
    </a>
  );
};
